import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { NotificationProvider } from "./hooks/useNotifications";
import Header from "./components/common/Header/Header";
import Footer from "./components/common/Footer/Footer";
import HomePage from "./components/pages/HomePage/HomePage";
import LoginPage from "./components/pages/LoginPage/LoginPage";
import RegisterPage from "./components/pages/RegisterPage/RegisterPage";
import TermsPage from "./components/pages/TermsPage/TermsPage";
import PrivacyPage from "./components/pages/PrivacyPage/PrivacyPage";
import ForgotPasswordPage from "./components/pages/ForgotPasswordPage/ForgotPasswordPage";
import CategoriesPage from "./components/pages/CategoriesPage/CategoriesPage";
import CategoryDetailPage from "./components/pages/CategoryDetailPage/CategoryDetailPage";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import AdminPanel from "./components/pages/AdminPanel/AdminPanel";
import TramiteManagementPage from "./components/pages/TramiteManagementPage/TramiteManagementPage";
import SolicitudesListView from "./components/pages/SolicitudesListView/SolicitudesListView";
import RequestPanel from "./components/pages/RequestPanel/RequestPanel";
import NewLoginPage from "./components/pages/NewLoginPage";
import StandaloneLogin from "./components/pages/StandaloneLogin";
import ImprovedDashboard from "./components/pages/ImprovedDashboard";
import AdvancedGestorPanel from "./components/pages/AdvancedGestorPanel";
import LoadingSpinner from "./components/common/LoadingSpinner/LoadingSpinner";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  // const { user, loading, token } = useAuth();

  // if (loading) {
  //   return <LoadingSpinner message="Verificando autenticación..." />;
  // }

  // return user ? children : <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  // const { user, loading, token } = useAuth();

  // if (loading) {
  //   return <LoadingSpinner message="Verificando autenticación..." />;
  // }

  // return user ? <Navigate to="/dashboard" replace /> : children;
  return children;
};

const AppRoutes = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/categorias" element={<CategoriesPage />} />
          <Route path="/categoria/:categorySlug" element={<CategoryDetailPage />} />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPasswordPage />
              </PublicRoute>
            }
          />

          <Route
            path="/terminos"
            element={
              <PublicRoute>
                <TermsPage />
              </PublicRoute>
            }
          />

          <Route
            path="/privacidad"
            element={
              <PublicRoute>
                <PrivacyPage />
              </PublicRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          } />


          <Route path="/admin/:tab" element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          } />


          <Route
            path="/gestor"
            element={
              <ProtectedRoute>
                <AdvancedGestorPanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/applications/:tramiteRequestId/documents"
            element={
              <ProtectedRoute>
                <TramiteManagementPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/applications"
            element={
              <ProtectedRoute>
                <SolicitudesListView />
              </ProtectedRoute>
            }
          />

          <Route
            path="/applications/:solicitudId"
            element={
              <ProtectedRoute>
                <RequestPanel />
              </ProtectedRoute>
            }
          />

          <Route path="/new-login" element={<NewLoginPage />} />

          <Route path="/standalone-login" element={<StandaloneLogin />} />

          <Route
            path="/improved-dashboard"
            element={
              <ProtectedRoute>
                <ImprovedDashboard />
              </ProtectedRoute>
            }
          />

          <Route path="/gestor-avanzado" element={<AdvancedGestorPanel />} />

          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-gray-600 mb-8">Página no encontrada</p>
                  <button onClick={() => (window.location.href = "/")} className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors">
                    Volver al Inicio
                  </button>
                </div>
              </div>
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AppRoutes />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
